<template>
	<div class="unavailable-items">
		<template v-if="items?.cart?.length">
			<div v-for="cart_error in items.cart" :key="cart_error.index" class="unavailable-item">
				<div class="title"><BaseCmsLabel :code="cart_error.label_name" tag="strong" /></div>
			</div>
		</template>
		<template v-if="warnings?.cart?.length">
			<div v-for="cart_warning in warnings.cart" :key="cart_warning.index" class="unavailable-item">
				<div class="title"><BaseCmsLabel :code="cart_warning.label_name" tag="strong" /></div>
				<div class="btn-edit-items" @click="closeWarning()">
					<span><BaseCmsLabel code="close" /></span>
				</div>
			</div>
		</template>
		<template v-if="data?.length">
			<template v-for="items in data" :key="items.number">
				<template v-for="item in items.items" :key="item.id">
					<div v-for="error in item.errors" :key="error.index" class="unavailable-item">
						<div :class="['title', {'special': error.qty == 0}]">
							<span class="label">
								<template v-if="error.label_name == 'error_price_changed'"> <BaseCmsLabel code="cart_error_price_changed" />&nbsp; </template>
								<template v-else-if="error.qty == 0"> <BaseCmsLabel code="cart_error_qty_empty" />&nbsp; </template>
								<template v-else-if="error.label_name == 'error_insurances_unavailable'">
									<BaseCmsLabel code="cart_error_insurances_unavailable" />
								</template>
								<template v-else> <BaseCmsLabel code="cart_error_qty" />&nbsp; </template>
							</span>

							<span class="value">
								<template v-if="item.item.title.length <= 20">{{ item.item.title }}</template>
								<template v-else>{{ item.item.title.substring(0,20)+"..." }}</template>
								<span v-if="error.label_name == 'error_price_changed'" class="price">
									<span class="line-through"><BaseUtilsFormatCurrency :price="error.old_price" /></span>
									<BaseUtilsFormatCurrency :price="error.new_price" />
								</span>
							</span>
						</div>

						<div v-if="error.label_name == 'error_price_changed'" class="btns">
							<div class="btn-edit-items" @click="priceConfirm()">
								<span><BaseCmsLabel code="cart_error_accept_new_price" /></span>
							</div>
							<div class="btn-edit-items" @click="webshop.removeProduct([{shopping_cart_code: item.shopping_cart_code}])">
								<span><BaseCmsLabel code="remove" /></span>
							</div>
						</div>
						<div v-else-if="error.qty == 0" class="btn-edit-items special" @click="webshop.removeProduct([{shopping_cart_code: item.shopping_cart_code}])">
							<span><BaseCmsLabel code="remove" /></span>
						</div>
						<a v-else href="javascript:void(0)" @click="scrollTo('#position-' + item.item.code, {offset: 90})" class="btn-edit-items"
							><span><BaseCmsLabel code="cart_edit_qty" /></span
						></a>
					</div>
				</template>
			</template>
		</template>
	</div>
</template>

<script setup>
	const props = defineProps(['data', 'items', 'warnings']);
	const webshop = useWebshop();
	const endpoints = useEndpoints();
	const { checkoutLoading } = useCheckout();
	const { scrollTo } = useDom();

	async function closeWarning() {
		checkoutLoading.value = true;

		let shopping_cart_codes = []
		props.warnings.cart.forEach(el => {
			el.shopping_cart_codes.forEach(el2 => {
				shopping_cart_codes.push({'shopping_cart_code':el2});
			})
		})

		await useApi(`${endpoints.get('_delete_hapi_webshop_product')}`, {
			method: 'DELETE',
			body: shopping_cart_codes
		}).then(async res => {
			await webshop.fetchCart()
		});

		checkoutLoading.value = false;
	}

	async function priceConfirm() {
		checkoutLoading.value = true;

		let cartCode = {}
		props.data.forEach(el => {
			el.items.forEach(el2 => {
				cartCode = el2.shopping_cart_code;
			})
		})

		let itemNewPrice = {};
		props.data.forEach(el => {
			el.items.forEach(el2 => {
				if(el2.errors){
					el2.errors.forEach(el3 => {
						itemNewPrice = el3.new_price;
					})
				}

			})
		})

		await useApi(`${endpoints.get('_post_hapi_webshop_accept_new_product_price')}`, {
			method: 'POST',
			body: {"shopping_cart_code": cartCode, "accept_price": itemNewPrice}
		}).then(async res => {
			if(res.success) {
				await webshop.fetchCart()
			}
		});

		checkoutLoading.value = false;
	}
</script>

<style lang="less" scoped>
	.unavailable-item{max-width: 1100px; margin: 0 auto;}
	.unavailable-item{
		display: flex; justify-content: space-between; border: 1px solid @red2; padding: 18px 25px; margin-top: -1px;
		@media (max-width: @m){padding: 13px 15px; display: block;}
		&.special{margin: 0 0 25px;}
		&:last-child{margin-bottom: 20px;}

		.title{
			padding-left: 30px; font-size: 15px; position: relative; font-weight: bold;
			&:before{
				.icon-available-last(); font: 17px/1 @fonti; color: @red2; position: absolute; top: 1px; left: 0;
				@media (max-width: @m){font-size: 15px; top: 4px;}
			}
			&.special:before{.icon-unavailable(); font-size: 15px; top: 3px; left: 2px;}
			@media (max-width: @m){
				padding-left: 25px; padding-bottom: 3px; font-weight: normal;
				&.special:before{top: 4px;}
			}
		}
		.price{
			display: block; margin-top: 10px; font-weight: bold;
			&>:first-child{margin-right: 5px;}
		}
		.btns{
			display: flex;
			&>*:last-child{
				margin-left: 10px; padding-left: 10px; position: relative;
				&:before{.pseudo(1px,10px); background: @red2; left: 0;}
			}
		}
		.btn-edit-items{
			display: flex; align-items: center; font-size: 15px; font-weight: 600; color: @red2; text-decoration: underline; text-underline-offset: 1px; cursor: pointer; position: relative;
			&.special{
				padding-right: 25px;
				&:after{.icon-trash(); font: 17px/1 @fonti; position: absolute; right: 0;}
			}
			&:hover{text-decoration: none;}

			@media (max-width: @m){
				font-size: 14px; display: block; text-align: right;
				&.special:after{top: 3px;}
			}
		}
		.btn-hidde{
			display: flex; align-items: center; flex-shrink: 0; margin-left: 20px; font-size: 15px; font-weight: 600; color: @red2; text-decoration: underline; text-underline-offset: 1px; cursor: pointer; position: relative;
			&:hover{text-decoration: none;}
		}
		@media (max-width: @m){
			.label{font-weight: bold;}
			.value{display: block; margin-left: -25px;}
		}
	}
</style>
